import { useQuery } from '@tanstack/react-query';
import qs from 'qs';

import { useApi, useAuth } from '../../hooks';

type Coach = {
  id: string;
  capacity: number;
  first_name: string;
  healthie_id: number;
  last_name: string;
};

export const useFetchCoaches = ({ active }: { active?: boolean } = {}) => {
  const { api } = useApi();
  const { userToken } = useAuth();

  const queryStr = qs.stringify({ active });

  const fetchCoaches = async () => {
    return await api({
      route: `/private/dashboard/coaches${queryStr ? `?${queryStr}` : ''}`,
      token: userToken,
    });
  };

  const { data, isLoading, isError } = useQuery<Coach[], Error>({
    queryFn: () => fetchCoaches(),
    queryKey: ['dashboard-coaches', active],
    // Coaches rarely change - avoid a redundant refetch every time a
    // second component (e.g. Toolbar) mounts and subscribes to this
    // same query key.
    staleTime: 30 * 1000,
  });

  return {
    data,
    isLoading,
    isError,
  };
};
